import { Loc, loadExtension, addCustomEvent, onCustomEvent, removeCustomEvent } from 'main.core';
import { BitrixVue } from 'ui.vue'
import Slick from '../plugins/vue-slick-carousel/vue-slick-carousel.umd.js';
import '../plugins/vue-slick-carousel/slick.css';
import './style.css';

export const Slider = (function () {
	const Slider = function ({ componentId, result, params }) {
		this.componentId = componentId;
		this.params = params;
		this.result = result;
		this.App = null;
		this.initialize();
	}
	Slider.prototype = {
		initialize() {
			const mountNode = document.getElementById(this.componentId),
				params = this.params,
				actions = this.result;
			this.App = BitrixVue.createApp({
				el: mountNode,
				name: 'Actions.List',
				store: userStore,
				components: {
					VueSlickCarousel: window['vue-slick-carousel']
				},
				data: {
					controller: 'germes:actions.list',
					isLoading: false,
					actionsItems: actions,
					params: params,
					slickOptions: {
						infinite: true,
						autoplay: true,
						mobileFirst: true,
						variableWidth: true,
						pauseOnHover: true,
						arrows: true,
						// lazyLoad: 'ondemand', // set attributes: data-lazy="..." src=""
						centerPadding: '15px',
						swipeToSlide: true,
						slidesToShow: 2,
						slidesToScroll: 1,
						responsive: [{
							breakpoint: 1200,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
							}
						}, {
							breakpoint: 1024,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
							}
						}, {
							breakpoint: 800,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}, {
							breakpoint: 480,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}]
					},
				},
				mounted() {
					addCustomEvent('OnAfterContragentChange', BX.delegate(function () {
						this.syncActions();
					}, this));
					this.syncActions();
				},
				computed: {
					cart(state) {
						return state.$store.getters['basket/getBasket'];
					},
					contragent(state) {
						return state.$store?.getters['basket/getContragent'];
					},
					actions(state) {
						return state.actionsItems ?? state.syncActions();
					},
				},
				methods: {
					syncActions: function () {
						if (this.contragent?.ID) {
							const storageKey = `actions-${this.contragent.ID}`;
							let storageActions;
							if (storageActions = this.loadFromLocalStorage(storageKey)) {
								this.actionsItems = storageActions;
							} else if (!this.isLoading) {
								this.isLoading = true;
								BX.ajax.runComponentAction(this.controller, 'getActiveList', {
									mode: 'ajax',
									data: {
										contragentId: this.contragent.ID,
									},
								}).then(response => {
									if (response.errors.legth) throw response;
									this.actionsItems = response.data;
									this.saveToLocalStorage(storageKey, this.actionsItems);
									this.reInit();
									return response;
								}, reject => {
									throw reject;
								}).catch(response => {
									this.isLoading = false;
									const errorMsg = response.errors.reduce((res, el) => el.message + ' ', '');
									this.notify({
										message: errorMsg,
										className: 'ui-notification-balloon-content-error'
									})
									return response;
								});
							}
						} else {
							this.reInit();
						}
					},
					reInit() {
						if (this.$refs.slick) {
							this.$nextTick(() => {
								this.$refs.slick?.reSlick();
							});
						} else {
							var sliderNode = this.$el.querySelector('.actions-slider');
							if (sliderNode instanceof HTMLElement) {
								$(sliderNode).slick(this.slickOptions);
							}
						}
					},
					// Функция загрузки данных из localStorage с учетом временной метки
					loadFromLocalStorage: function (key) {
						const storageKey = this.getLocalStorageKey(key);
						const savedData = localStorage?.getItem(storageKey);
						if (!savedData) {
							return null;
						}
						try {
							const parsedData = JSON.parse(savedData);
							// Проверяем, не истек ли срок действия
							if (!parsedData.ttl || parsedData.ttl < Date.now()) {
								console.warn(`Данные по ключу ${storageKey} устарели и будут удалены.`);
								this.removeFromLocalStorage(storageKey);
								return null;
							}
							return parsedData.data;
						} catch (error) {
							console.error('Ошибка при парсинге данных:', error);
							return null;
						}
					},
					/**
					 * Функция сохранения данных в localStorage с добавлением временной метки
					 * @param {string} key - ключ для сохранения
					 * @param {any} value - данные для сохранения
					 * @param {number} ttl - время жизни данных в миллисекундах (по умолчанию 20 минут)
					 */
					saveToLocalStorage: function (key, value, ttl = 1200000) {
						const storageKey = this.getLocalStorageKey(key);
						const dataToSave = {
							ttl: Date.now() + ttl,
							data: value
						};
						localStorage?.setItem(storageKey, JSON.stringify(dataToSave));
					},
					// Функция удаления данных из localStorage
					removeFromLocalStorage: function (key) {
						const storageKey = this.getLocalStorageKey(key);
						localStorage?.removeItem(storageKey);
					},
					getLocalStorageKey: function (key) {
						if (!key.startsWith(this.userId + '-')) {
							return this.userId + '-' + key;
						}
						return key;
					},
				},
				/* template: `<div class="actions-slider">
							<template v-if="actionsItems != null && actionsItems.length > 0">
								<div class="slider-catalog">
								<VueSlickCarousel v-bind="slickOptions" ref="slick">
										<div v-for="actionItem in actionsItems" class="slider-catalog-item">
											<img src="/local/components/germes/hl.actions.list/templates/actions/images/sale.png" class="action-head-icon float-right" :title="actionItem.NAME" width="60" height="60" loading="lazy">
											<h2><a :href="actionItem.DETAIL_URL" :title="actionItem.NAME" target="_top" rel="index">{{actionItem.NAME}}</a></h2>
											<div>
											<span v-if="actionItem.SALE_SUMM > 0" title="Есть оформленный заказ" class="text-success d-inline float-right"><i class="fas fa-check-circle"></i></span>
											{{actionItem.LEFT_DAYS_TEXT}} <span v-if="actionItem.LEFT_DAYS > 0" class="text-danger">{{actionItem.LEFT_DAYS_TEXT_REMAINED}}</span>
											</div>
										</div>
								</VueSlickCarousel>
								</div>
							</template>
						</div>` */
			});
		}
	}
	return Slider;
})();
